import React, { PureComponent } from "react";
import Heading from "components/Elements/Heading";
import SummaryChannelByType from "components/Summary/SummaryChannelByType";
import {
  getMetricForColumn,
  Metric,
  renderTrendTable,
  sortNumeric,
  Error,
  TableContentColoredIcon,
  selectFormat,
} from "components/Utils/Utils";
import moment from "moment-timezone";

class WorldCupStreamingPerformance extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: [
      {
        Metric: "Total Visitors Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.totalVisitors.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.totalMinutes.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes Yesterday Live",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.totalMinutes.data[0].current.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Minutes Yesterday Live (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.totalMinutes.data[0].previous.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Minutes Yesterday Replay",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.totalMinutes.data[1].current.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes Yesterday Replay (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.totalMinutes.data[1].previous.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes Yesterday Highlight",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.totalMinutes.data[2].current.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes Yesterday Highlight (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.totalMinutes.data[2].previous.value,
          "0,0"
        ),
      },

      // Video Starts Yesterday

      {
        Metric: "Video Starts Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.videoStarts.value,
          "0,0"
        ),
      },

      {
        Metric: "Video Starts Yesterday Live",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.videoStarts.data[0].current.value,
          "0,0"
        ),
      },
      {
        Metric: "Video Starts Yesterday Live (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.videoStarts.data[0].previous.value,
          "0,0"
        ),
      },
      {
        Metric: "Video Starts Yesterday Replay",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.videoStarts.data[1].current.value,
          "0,0"
        ),
      },

      {
        Metric: "Video Starts Yesterday Replay (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.videoStarts.data[1].previous.value,
          "0,0"
        ),
      },

      {
        Metric: "Video Starts Yesterday Highlight",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.videoStarts.data[2].current.value,
          "0,0"
        ),
      },

      {
        Metric: "Video Starts Yesterday Highlight (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.yesterday.videoStarts.data[2].previous.value,
          "0,0"
        ),
      },

      // Vistors To Date

      {
        Metric: "Total Visitors To Date",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.totalVisitors.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes To Date",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.totalMinutes.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes To Date Live",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.totalMinutes.data[0].current.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Minutes To Date Live (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.totalMinutes.data[0].previous.value,
          "0,0"
        ),
      },
      {
        Metric: "Total Minutes To Date Replay",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.totalMinutes.data[1].current.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes To Date Replay (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.totalMinutes.data[1].previous.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes To Date Highlight",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.totalMinutes.data[2].current.value,
          "0,0"
        ),
      },

      {
        Metric: "Total Minutes To Date Highlight (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.totalMinutes.data[2].previous.value,
          "0,0"
        ),
      },

      // Video Starts To Date

      {
        Metric: "Video Starts To Date",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.videoStarts.value,
          "0,0"
        ),
      },

      {
        Metric: "Video Starts To Date Live",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.videoStarts.data[0].current.value,
          "0,0"
        ),
      },
      {
        Metric: "Video Starts To Date Live (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.videoStarts.data[0].previous.value,
          "0,0"
        ),
      },
      {
        Metric: "Video Starts To Date Replay",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.videoStarts.data[1].current.value,
          "0,0"
        ),
      },

      {
        Metric: "Video Starts To Date Replay (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.videoStarts.data[1].previous.value,
          "0,0"
        ),
      },

      {
        Metric: "Video Starts To Date Highlight",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.videoStarts.data[2].current.value,
          "0,0"
        ),
      },

      {
        Metric: "Video Starts To Date Highlight (Previous)",
        Value: selectFormat(
          "number",
          this.props.data.qatarToDate.videoStarts.data[2].previous.value,
          "0,0"
        ),
      },
    ],
    opts: {
      type: "other",
    },
  });

  render() {
    const { data, url } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    const defaultColors = {
      live: "#fc6d52",
      replay: "#fcd239",
      highlight: "#15c8de",
    };

    const chartColumns = [
      {
        dataField: "title",
        text: "",
        sort: false,
        style: { width: "30%", minWidth: "30%" },
        formatter: (cell, row, rowIndex, opts) =>
          TableContentColoredIcon(
            cell,
            row,
            rowIndex,
            opts,
            defaultColors[cell.toLowerCase()]
          ),
      },
      {
        dataField: "current",
        text: "",
        sort: false,
        style: { width: "30%", minWidth: "30%" },
        formatter: getMetricForColumn,
        formatExtraData: { format: "0,0" },
        sortFunc: sortNumeric,
      },

      {
        dataField: "previous",
        text: "",
        sort: false,
        style: { width: "30%", minWidth: "30%" },
        formatter: getMetricForColumn,
        formatExtraData: { format: "0,0" },
        sortFunc: sortNumeric,
      },
      {
        dataField: "change",
        text: "",
        sort: false,
        style: { width: "10%", minWidth: "10%" },
        formatter: renderTrendTable,
        sortFunc: sortNumeric,
      },
    ];

    const streamingWidget = (
      title,
      totalVisitorsTitle,
      videoMinutesTitle,
      videoStartsTitle,
      data,
      date
    ) => {
      return (
        <div className="col-sm-12 col-md-6 world-cup-streaming-performance">
          <div className="row">
            <div className="col-12">
              <div className="my-3">
                <div className="mb-2 col-12">
                  <Heading size={5} className={"mb-6 world-cup-widget-title"}>
                    {title}
                    {date && (
                      <div className="d-inline-block text-gray font-weight-light">
                        &nbsp; -{" "}
                        {moment(date).subtract(1, "days").format("dddd, ll")}
                      </div>
                    )}
                  </Heading>
                  <Heading size={5} className={"mb-6"}>
                    {totalVisitorsTitle}
                  </Heading>
                  <Metric
                    {...{ ...data.totalVisitors }}
                    size={"lg"}
                    widgetClassName="metric--lg align-items-end"
                    chartTrendClassName="d-flex flex-row align-items-center ml-2 mb-1"
                    comparison={"vs " + data.totalVisitors.comparison}
                  />
                </div>
              </div>
              <div className="my-3">
                <div className="mb-2 col-12">
                  <Heading size={5} className={"mb-6"}>
                    {videoMinutesTitle}
                  </Heading>
                  <Metric
                    {...{ ...data.totalMinutes }}
                    size={"lg"}
                    widgetClassName="metric--lg align-items-end"
                    chartTrendClassName="d-flex flex-row align-items-center ml-2 mb-1"
                    comparison={"vs " + data.totalMinutes.comparison}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <SummaryChannelByType
                data={data.totalMinutes.data}
                columns={chartColumns}
                graph={data.totalMinutes.graph}
                elementColors={defaultColors}
                hideColumns={true}
              />
            </div>
          </div>

          {/* KPI below */}
          <div className="row">
            <div className="col-12">
              <div className="my-3">
                <div className="mb-2 col-12">
                  <Heading size={5} className={"mb-6"}>
                    {videoStartsTitle}
                  </Heading>
                  <Metric
                    {...{ ...data.videoStarts }}
                    size={"lg"}
                    widgetClassName="metric--lg align-items-end"
                    chartTrendClassName="d-flex flex-row align-items-center ml-2 mb-1"
                    comparison={"vs " + data.videoStarts.comparison}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <SummaryChannelByType
                data={data.videoStarts.data}
                columns={chartColumns}
                graph={data.videoStarts.graph}
                elementColors={defaultColors}
                hideColumns={true}
              />
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="row border-between-metrics pt-0">
        {streamingWidget(
          "Yesterday",
          "Total Visitors Yesterday",
          "Video Minutes Yesterday",
          "Video Starts Yesterday",
          data.yesterday,
          new Date()
        )}
        {streamingWidget(
          url.includes("world-cup-2023") ? "World Cup 2023" : "Qatar to Date",
          "Total Visitors To Date",
          "Video Minutes Total to Date",
          "Video Starts Total To Date",
          data.qatarToDate
        )}
      </div>
    );
  }
}

export default WorldCupStreamingPerformance;
